<template>
  <div class="page-content">
    <div class="content">
      <h1 class="page-title">{{ $t('intro.title') }}</h1>
      <div class="intro-section">
        <img
          src="../assets/img/xiangmujieshao.png"
          alt="项目介绍"
          class="section-image"
        />
        <div class="article">
          <p>{{ $t('intro.content') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
};
</script>

<style scoped>
.page-content {
  min-height: calc(100vh - 160px);
  width: 100%;
  padding: 0;
  background: var(--bg-primary);
}

.content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 30px 15px;
  background: var(--bg-primary);
}

.page-title {
  font-size: 42px;
  line-height: 56px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 20px;
  border-bottom: 3px solid var(--accent-primary);
}

.intro-section {
  margin-top: 30px;
}

.section-image {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto 40px;
}

.article {
  font-size: 18px;
  line-height: 36px;
  color: var(--text-secondary);
  text-align: justify;
  padding: 0 10px 30px;
  width: 100%;
}

.article p {
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .content {
    padding: 20px 10px;
  }

  .page-title {
    font-size: 28px;
    line-height: 36px;
    margin-bottom: 30px;
    padding-bottom: 15px;
  }

  .article {
    font-size: 16px;
    line-height: 28px;
    padding: 0 5px 20px;
  }

  .section-image {
    margin-bottom: 20px;
  }
}
</style>
